/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {Component} from "react";
import {Redirect} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {API} from "lib/API"

class LogOut extends Component {
    constructor(props) {
        super(props)
        this.state = {
          loaded: false,
          ssoOn: false
        }
    }
    componentDidMount() {
      let sessionMode = API.isSsoModeOn();
      API.clearSessionMode();
      if(sessionMode) {
        window.location.href = "/session/login";
      }
      if(!sessionMode) {
        API.clearBeat();
        API.user.get("/session/logout");
        sessionStorage.clear();
      }

      this.setState({
        loaded: true,
        ssoOn: sessionMode
      });
    }

  render() {
    if(this.state.loaded) {
      if(this.state.ssoOn) {
        return <Redirect to={{pathname: '/admin/home'}}/>;
      } else {
        return <Redirect to={{pathname: '/auth/login'}}/>;
      }
    }
    return ( <div/> );

  }
}

export default withTranslation()(LogOut);